module.exports = __webpack_public_path__ + "static/media/Back_equipe.c0e39835.jpg";